import { hasRanking } from '../../../lib/gameOrder';

// Display helpers shared by the games table (desktop) and game cards (phones).

const kickoffDay = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' });
const kickoffTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });

export const formatKickoff = (startTime) => {
  if (!startTime?.seconds) return '—';
  const date = new Date(startTime.seconds * 1000);
  return `${kickoffDay.format(date)} · ${kickoffTime.format(date)}`;
};

export const teamLabel = (teams, id, ranking) => {
  const name = teams.find((team) => team.id === id)?.name || id || '—';
  return hasRanking(ranking) ? `#${ranking} ${name}` : name;
};

export const hasScore = (value) => value !== undefined && value !== null && value !== '';

export const hasFinalScore = (game) => hasScore(game.awayScore) && hasScore(game.homeScore);

// Why a game can't be moved to another week, or '' when it can. Mirrors the
// server's refusals (functions/lib/moveGames.js) so the checkbox says so first.
export const moveBlockReason = (game, now = Date.now()) => {
  if (!game.startTime?.seconds) return 'No kickoff time';
  if (game.startTime.seconds * 1000 <= now) return 'Already kicked off';
  if (hasScore(game.awayScore) || hasScore(game.homeScore)) return 'Already has a score';
  return '';
};

export const scoringLabel = (game) => (
  game.isPickScore ? (game.awardWinnerBonus ? 'Score + Winner' : 'Score') : 'Winner'
);

export const emptyWeekMessage = (week) => (
  week
    ? `No games in Week ${week} yet. Import games from the API or add one by hand.`
    : 'Pick a week to see its games.'
);
